/** The property photo upload contract (also used by the existing image uploader). */
export const PROPERTY_IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"] as const;
export const PROPERTY_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

export function isSafePropertyVideoUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return (url.protocol === "http:" || url.protocol === "https:") && !!url.hostname && !url.username && !url.password;
  } catch {
    return false;
  }
}
